import { BADGES_NAMES, BADGES_NEW, DISCOUNT, EXCLUSIVE } from '@/utils/facetConstants';

export default {
  computed: {
    productBadges() {
      if (!this.product?.badges?.length) {
        return false;
      }

      const maxBadgeCount = 2;
      const result = {};

      for (const [name, badgeType] of Object.entries(BADGES_NAMES)) {
        const badgeData = this.product.badges.find((badge) => badge.type === badgeType);

        if (!badgeData) {
          continue;
        }

        switch (badgeType) {
          case PRICETIP:
            result[name] = badgeData.name;
            break;
          case DISCOUNT:
            if (this.product.pricing?.friendsPrice?.value || !this.product.pricing?.savingsRelative?.value) {
              break;
            }
            result[name] = this.product.pricing?.savingsRelative?.formattedValue;
            break;
          case DEAL:
            result[name] = badgeData.name;
            break;
          case BADGES_NEW:
            result[name] = this.$t('product.badgesNew.new');
            break;
          case EXCLUSIVE:
            result[name] = this.$t('product.badgesNew.exclusive');
            break;
          default:
            result[name] = '';
        }

        if (Object.keys(result).length >= maxBadgeCount) {
          break;
        }
      }

      return result;
    },
  },
};
